import { ApplicationResourcesFormat } from '@/application/ApplicationResourcesFormat'
import Facade from '@/Facade'
import { PlatformUtil } from '@/utils/PlatformUtil'
import { ResourceUtil } from '@/utils/ResourceUtil'
import * as PIXI from 'pixi.js'

// Note: PixiJS v8 usa il nuovo sistema di Assets invece di Loader
export type EditableLoaderResource = Partial<any> & {
    extension: string
    url: string
}

export class ApplicationAssetsLoader {
    public static pre(format: string, resource: EditableLoaderResource, next: () => void): void {
        // Note: PIXI.Loader è deprecato in v8 - da migrare a PIXI.Assets
        if ((resource as any).loadType === 1) { // LOAD_TYPE.IMAGE
            if (resource.url.indexOf('/moduleAssets/') === -1 && resource.extension === 'png') {
                resource.extension = format
                resource.url = resource.url.replace('.png', '.' + format)
            }
        }

        next()
    }

    public static use(resource: any, next: () => void): void {
        // Note: PIXI.Loader è deprecato in v8 - da migrare a PIXI.Assets
        if (resource.type === 3) { // TYPE.IMAGE
            const renderer = Facade.renderer

            if (renderer != null && resource.texture != null) {
                const baseTexture = resource.texture.baseTexture
                if (baseTexture) {
                    baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR
                    // mipmap gestito automaticamente in v8
                }
            }
        }

        if (resource.data == null || resource.type !== 4) { // TYPE.JSON
            next()
            return
        }

        if (resource.data.metadata != null && resource.data.metadata.type === 'assetsList') {
            const assets = resource.data.assets

            if (assets != null && assets.length > 0) {
                const options: any = {
                    crossOrigin: resource.crossOrigin,
                    parentResource: resource,
                    metadata: {},
                }

                for (const asset of assets) {
                    options.name = asset.name
                    options.url = ResourceUtil.resolveUrl(resource.url, asset.path)
                    // Note: this.add non disponibile - da migrare a PIXI.Assets
                    console.warn('Asset loading needs migration to PIXI.Assets API')
                }
            }
        }

        next()
    }

    public static registerLoaderMiddleware(): void {
        // Note: PIXI.Loader è deprecato in PixiJS v8
        // Il nuovo sistema PIXI.Assets gestisce il loading automaticamente
        // Questa funzione è mantenuta per compatibilità ma non fa nulla
        console.log('Loader middleware not required in PixiJS v8')
        
        // Manteniamo la logica per il formato immagine se necessario
        if (PlatformUtil.isSafariBrowser()) {
            if (ApplicationResourcesFormat.JP2_FORMAT_ENABLED && PlatformUtil.isFormatSupported('image/jp2')) {
                console.log('JP2 format supported')
            }
        } else {
            if (ApplicationResourcesFormat.WEBP2_FORMAT_ENABLED && PlatformUtil.isFormatSupported('image/webp')) {
                console.log('WebP format supported')
            }
        }
    }

    public static removeSpineMiddleware(): void {
        // Note: In PixiJS v8 con @esotericsoftware/spine-pixi-v8, 
        // il loading è gestito automaticamente dal sistema Assets
        // Non è più necessario rimuovere middleware manualmente
        if (ApplicationResourcesFormat.MERGED_SPINE_ATLASES_ENABLED) {
            console.log('Spine middleware handling not required in PixiJS v8')
        }
    }
}
